import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import Page1Mobile from "../components/Page1Mobile";
import Page2Mobile from "../components/Page2Mobile";
import Page3Mobile from "../components/Page3Mobile";
import Page4Mobile from "../components/Page4Mobile";
import Page5Mobile from "../components/Page5Mobile";
import Page6Mobile from "../components/Page6Mobile";
import NavbarMobile from "../components/NavbarMobile";

export default function HomeMobile() {
  const [showNav, setShowNav] = useState(true);
  const [y, setY] = useState(window.scrollY);

  const handleNavigation = useCallback(
    (e) => {
      const window = e.currentTarget;
      if (y > window.scrollY) {
        setShowNav(true);
      } else if (y < window.scrollY) {
        setShowNav(false);
      }
      setY(window.scrollY);
    },
    [y]
  );

  useEffect(() => {
    setY(window.scrollY);
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);
  return (
    <Column>
      <NavbarMobile show={showNav} />
      <Page1Mobile />
      <Page2Mobile />
      <Page3Mobile />
      <Page4Mobile />
      <Page5Mobile />
      <Page6Mobile />
    </Column>
  );
}

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
`;
